import _ from 'lodash';
import React, { ReactElement, useState } from 'react';
import { Button, Drawer, Timeline } from 'antd';
import './borrow.less';
import Tick from '@/UI/Tick';
import ArrowForward from '@/UI/ArrowForward';
import Layout from './Layout';

export default function LeftDrawerLayout(props: {
    pageName: string;
    currentStep: number;
    children: JSX.Element | JSX.Element[];
}): ReactElement {
    const [ isDrawerOpen, setIsDrawerOpen ] = useState(false);
    const {
        currentStep,
        children,
        pageName,
    } = props;

    const onClickOpenProgress: () => void = (): void => {
        setIsDrawerOpen(true);
    };

    const onClickCloseProgress: () => void = (): void => {
        setIsDrawerOpen(false);
    };

    const timelineItems: {children: ReactElement; dot: ReactElement}[] = _.map(
        [ 'Applicant info', 'Loan details', 'Loan purpose', 'Secured property' ],
        (label: string, step: number) => ({
            children: (
                <div className={`step ${currentStep > step + 1 ? 'completed' : currentStep === step + 1 ? 'active' : ''}`}>
                    {label}
                </div>
            ),
            dot: (
                <div className={`step-circle ${currentStep > step + 1 ? 'completed' : currentStep === step + 1 ? 'active' : ''}`}>{currentStep > step + 1 ? (<Tick className='completed-icon' />) : <div className='step-number'>{step + 1}</div>}</div>
            ),
        }),
    );

    return (
        <Layout pageName={pageName}>
            <main className='left-drawer-layout' role='main'>
                <div className='left-section'>
                    <Timeline className='timeline' items={timelineItems} />
                </div>
                <Drawer
                    className='left-drawer'
                    closeIcon={false}
                    getContainer={false}
                    mask={false}
                    maskClosable={true}
                    open={isDrawerOpen}
                    placement='left'
                >
                    <Button
                        className='progress-button'
                        icon={<ArrowForward />}
                        iconPosition='end'
                        type='default'
                        onClick={onClickCloseProgress}
                    >
                        {currentStep} of {timelineItems.length}
                    </Button>
                    <div className='left-section'>
                        <Timeline className='timeline' items={timelineItems} />
                    </div>
                </Drawer>
                <div className='main-section'>
                    <div className='body'>
                        <div className='main-box'>
                            <Button
                                className='progress-button'
                                icon={<ArrowForward />}
                                iconPosition='end'
                                type='default'
                                onClick={onClickOpenProgress}
                            >
                                {currentStep} of {timelineItems.length}
                            </Button>
                            {children}
                        </div>
                    </div>
                </div>
            </main>
        </Layout>
    );
}

